import { isDefinedObject } from "et3-type-guards";
import getSupervisorReceiptStore from "../../../../../stores/supervisor-store/supervisor-receipt-compensation-store";
import Et3Button from "../../../../../core/et3-button";
import ET3Div from "../../../../../core/et3-div";
import { withLiteObserverAndTheme } from "../../../../../core/et3-enhanced-render";

const SaveReceiptIssuesCount = withLiteObserverAndTheme((props) => {
  const { theme } = props;
  const { colors } = theme;
  const showSaveButton = isDefinedObject(
    getSupervisorReceiptStore().dataInputObject.get()
  );
  return !showSaveButton ? null : (
    <ET3Div
      isScrollable={false}
      isExtendable={false}
      fDirection="row"
      justifyContent="flex-end"
      alignItems="flex-end"
      withShadow={false}
      width={800}
      height={110}
      color={colors.all.transparent}
      style={{}}
      onClick={() => {}}
    >
      <Et3Button
        onClick={async () =>
          await getSupervisorReceiptStore().saveSupervisorIssues()
        }
        isEnabled={true}
        size="LARGE"
        text="SAVE"
        type="GET"
      />
    </ET3Div>
  );
});
export default SaveReceiptIssuesCount;
